import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import NotFound from "@/pages/NotFoundPage.vue";

let server = [
    //UNIVERSALS
    {
        path: "dashboard",
        name: "Главная",
        component: () => import('@/pages/Dashboard.vue')
    },
    {
        path: "businesses_change",
        name: "Выбрать бизнес",
        component: () => import('@/pages/BusinessesChange.vue')
    },
    {
        path: "quit",
        name: "Выход",
        component: () => import('@/pages/Quit.vue')
    },
    {
        path: "logs",
        name: "Логи",
        component: () => import('@/pages/Logs.vue')
    },
    //ROOT
    {
        path: "lessonplans",
        name: "Плановые уроки",
        component: () => import('@/pages/Lessonplans.vue')
    },
    {
        path: "disciplines",
        name: "Плановые уроки",
        component: () => import('@/pages/Disciplines.vue')
    },
    {
        path: "customer_clouds",
        name: "Все пользовтали",
        component: () => import('@/pages/CustomerClouds.vue')
    },
    {
        path: "guardian_clouds",
        name: "Все родители",
        component: () => import('@/pages/GuardianClouds.vue')
    },
    {
        path: "client_clouds",
        name: "Все ученики",
        component: () => import('@/pages/ClientClouds.vue')
    },
    {
        path: "businesses",
        name: "Список школ",
        component: () => import('@/pages/Businesses.vue')
    },
    {
        path: "rating/clients",
        name: "",
        component: () => import('@/pages/Rating/RatingClients.vue')
    },
    {
        path: "rating/groups",
        name: "",
        component: () => import('@/pages/Rating/RatingGroups.vue')
    },

    //new format

    //FOR BUSINESSES
    {
        path: "groups",
        name: "Классы",
        component: () => import('@/pages/Groups.vue')
    },
    {
        path: "clients",
        name: "Ученики",
        component: () => import('@/pages/Clients.vue')
    },
    {
        path: "summaryreports",
        name: "Отчёт о движении",
        component: () => import('@/pages/SummaryReports.vue')
    },
    {
        path: "customers",
        name: "Пользователи",
        component: () => import('@/pages/Customers.vue')
    },
    {
        path: "guardians",
        name: "Родители",
        component: () => import('@/pages/Guardians.vue')
    },
    {
        path: "schedules",
        name: "Расписание дня",
        component: () => import('@/pages/Schedules.vue')
    },
    {
        path: "seasons",
        name: "Учебные сезоны",
        component: () => import('@/pages/Seasons.vue')
    },
    {
        path: "pupils",
        name: "Мои классы",
        component: () => import('@/pages/Pupils.vue')
    },
    {
        path: "stats",
        name: "Отчетность",
        component: () => import('@/pages/Progress/GroupStat.vue')
    },
    {
        path: "journal",
        name: "Отчетность",
        component: () => import('@/pages/Progress/Journal.vue')
    },
    {
        path: "categories",
        name: "Группы предметов",
        component: () => import('@/pages/Categories.vue')
    },
    {
        path: "attendance",
        name: "Посещаемость",
        component: () => import('@/pages/Attendance.vue')
    },
    {
        path: "texts",
        name: "",
        component: () => import('@/pages/Texts.vue')
    },
    {
        path: "processes",
        name: "",
        component: () => import('@/pages/Processes.vue')
    },
    {
        path: "transactions",
        name: "",
        component: () => import('@/pages/Transactions.vue')
    },
    {
        path: "tariffs",
        name: "",
        component: () => import('@/pages/Tariffs.vue')
    },
    {
        path: "payments",
        name: "",
        component: () => import('@/pages/Payments.vue')
    },
    {
        path: "holidays",
        name: "",
        component: () => import('@/pages/Holidays.vue')
    },
    {
        path: "works",
        name: "",
        component: () => import('@/pages/Works.vue')
    },

    {
        path: "themes",
        name: "",
        component: () => import('@/pages/Themes.vue')
    },
    {
        path: "authors",
        name: "",
        component: () => import('@/pages/Authors.vue')
    },
    {
        path: "jobspositions",
        name: "Должности",
        component: () => import('@/pages/JobsPositions.vue')
    },
    {
        path: "/questions/:id",
        name: "",
        component: () => import('@/pages/Questions.vue'),
        props: true,
    },

];

const routes = [
    {
        path: "/",
        component: DashboardLayout,
        redirect: "/dashboard",
        children: server
    },
    { path: "*", component: NotFound }
];

export default routes;
